import script from "./TheHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHome.vue?vue&type=script&setup=true&lang=js"

import "./TheHome.vue?vue&type=style&index=0&id=b2f0ebb8&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2f0ebb8"]])

export default __exports__